import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso2pagePageRoutingModule } from './paso2page-routing.module';
import {MiscomponentesModule} from '../miscomponentes/componentes.module'

import { Paso2pagePage } from './paso2page.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MiscomponentesModule,
    Paso2pagePageRoutingModule
  ],
  declarations: [
    Paso2pagePage,
  ]
})
export class Paso2pagePageModule {}
